import { GTDriverDocumentCategoryInput } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const documentsMessages = defineMessages({
  [GTDriverDocumentCategoryInput.Photo]: {
    id: 'drivers.form.driverPhoto.label',
    defaultMessage: 'Driver Photo'
  },
  [GTDriverDocumentCategoryInput.Licence]: {
    id: 'drivers.form.license.label',
    defaultMessage: 'License'
  },
  [GTDriverDocumentCategoryInput.Id]: {
    id: 'drivers.form.officialId.label',
    defaultMessage: 'Official ID (INE)'
  },
  [GTDriverDocumentCategoryInput.BirthCertificate]: {
    id: 'drivers.form.birthCertificate.label',
    defaultMessage: 'Birth Certificate'
  },
  [GTDriverDocumentCategoryInput.ProofOfAddress]: {
    id: 'drivers.form.proofOfAddress.label',
    defaultMessage: 'Proof of Address'
  },
  [GTDriverDocumentCategoryInput.Curp]: {
    id: 'drivers.form.curp.label',
    defaultMessage: 'CURP'
  },
  [GTDriverDocumentCategoryInput.ProofOfLastStudy]: {
    id: 'drivers.form.proofOfLastStudies.label',
    defaultMessage: 'Proof of Last Studies'
  },
  [GTDriverDocumentCategoryInput.Application]: {
    id: 'drivers.form.application.label',
    defaultMessage: 'Application'
  }
})
